import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type SearchWord = {
  search_word_id?: number; // 추천검색어 idx
  search_word?: string; // 추천 검색어
  is_show?: string; // 노출 여부
  order?: number; // 순서
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] SearchWord
   * --
   */
  getSearchWords: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_SEARCH_WORD, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] SearchWord
   * --
   */
  getSearchWord: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_SEARCH_WORD, {
        search_word_id: idx,
      });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] SearchWord
   * --
   */
  createSearchWord: async (body: SearchWord) => {
    try {
      const res = await $http.post(APIConstant.CREATE_SEARCH_WORD, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] SearchWord
   * --
   */
  updateSearchWord: async (body: SearchWord) => {
    try {
      const { search_word_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_SEARCH_WORD, {
        search_word_id: search_word_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] SearchWord
   * --
   */
  deleteSearchWord: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_SEARCH_WORD, {
        search_word_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] SearchWord
   * --
   */
  upsertSearchWord: async (body: SearchWord[]) => {
    try {
      const res = await $http.bulk(
        APIConstant.BULK_UPSERT_SEARCH_WORD,
        body,
        'PUT'
      );
      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
